export default{
	//失败提示
	errMsg(_that,msg){
		_that.$message.error(msg);
	},
}


// WEBPACK FOOTER //
// ./src/page/common/common.js